export enum MONTHS {
  JANUARY = 'January',
  FEBRUARY = 'February',
  MARCH = 'March',
  APRIL = 'April',
  MAY = 'May',
  JUNE = 'June',
  JULY = 'July',
  AUGUST = 'August',
  SEPTEMBER = 'September',
  OCTOBER = 'October',
  NOVEMBER = 'November',
  DECEMBER = 'December',
}

export enum MONTHS_DE {
  JANUARY = 'Januar',
  FEBRUARY = 'Februar',
  MARCH = 'März',
  APRIL = 'April',
  MAY = 'Mai',
  JUNE = 'Juni',
  JULY = 'Juli',
  AUGUST = 'August',
  SEPTEMBER = 'September',
  OCTOBER = 'Oktober',
  NOVEMBER = 'November',
  DECEMBER = 'Dezember',
}
